import api from '.';

const rolesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    requestRoles: builder.query({
      query: () => ({
        url: `/roles`,
        method: 'GET'
      })
    }),
    requestUserRoles: builder.query({
      query: ({ id }) => ({
        url: `/roles/${id}/users`,
        method: 'GET'
      })
    })
  })
});

export default rolesApi;
export const { useRequestRolesQuery, useRequestUserRolesQuery } = rolesApi;
